import React from "react"
export function UploadFailedFill(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M10 2a8 8 0 110 16 8 8 0 010-16zm.875 11.111H9.132v1.556h1.743V13.11zm-.237-7.778H9.45a1 1 0 00-1 1.023l.01.116.714 5.084h1.742l.712-5.084a1 1 0 00-.874-1.132l-.116-.007z"
        fill="currentColor"
        id="prefix__upload-failed---fill"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}
